import { Box } from "@mui/material";
import Header from "./header";
import LayoutComponent from "./Layout";

const SvgComponent = (props) => {
    const { data, loader, active, selectBlock, selectPart, setSelectBlock, setSelectPart, isSelect, setIsSelect, activityId, onBlockClick } = props;
    const { svgMap, projectList, blocks, overAllSVG, list, svgProgressBlockWise } = data;
    const project_id = localStorage.getItem("project_id");
    const project_name = projectList.find((item) => item.id === parseInt(project_id ?? "0"));

    return (
        <Box px={4} py={2}>
            <Header
                projectList={projectList}
                loader={loader}
                title={active}
                setSelectPart={setSelectPart}
                setSelectBlock={setSelectBlock}
                selectBlock={selectBlock}
                setIsSelect={setIsSelect}
                isSelect={isSelect}
            />
            <LayoutComponent
                loader={loader}
                svgMap={svgMap}
                project_name={project_name}
                scale={Number(project_name?.svg_dimension?.web?.web_svg_initial_scale) * 2}
                blocks={blocks}
                overAllSVG={overAllSVG}
                svgProgressBlockWise={svgProgressBlockWise}
                activityId={activityId}
                list={list}
                selectPart={selectPart}
                setSelectPart={setSelectPart}
                selectBlock={selectBlock}
                isSelect={isSelect}
                onBlockClick={onBlockClick}
            />
        </Box>
    );
};

export default SvgComponent;